import { Routes } from '@angular/router';

// Components
import { LocationListComponent } from './Components/location-list/location-list.component';
import { LocationDetailComponent } from './Components/location-detail/location-detail.component';
import { LocationAddComponent } from './Components/location-add/location-add.component';
import { LocationEditComponent } from './Components/location-edit/location-edit.component';

export const locationRoutes: Routes = [
    { path: 'locations', component: LocationListComponent, data: { title: 'Locations', icon: 'location_on', primary: true }},
    { path: 'locations/add', component: LocationAddComponent, data: { primary: false }},
    { path: 'locations/:id', component: LocationDetailComponent, data: { primary: false }},
    { path: 'locations/edit/:id', component: LocationEditComponent, data: { primary: false }}
];